import { addPointClient, getCodeClient } from "../services/api.service";
import Swal from "sweetalert2";
import moment from "moment-timezone"; 
import { information } from "../information";


export const getCode = async (codeID) => {
  let codeResult = await getCodeClient(codeID);
  if (codeResult.status_code === 403) {
    let time = moment(codeResult.detail.time).tz("Asia/Ho_Chi_Minh").format("YYYY/MM/DD H:mm:ss");
    Swal.fire({
      icon: "error",
      allowOutsideClick: false,
      title: codeResult.title_mess,
      html:
        "<div class='modal-text-wrapper'>" +
        "<div class='modal-text-cont'>" +
        "<p class='modal-text'>Mã khuyến mãi: &nbsp;</p>" +
        "<p style='font-weight: 600'>" +
        codeResult.detail.promo_code +
        "</p>" +
        "</div>" +
        "<div class='modal-text-cont'>" +
        "<p class='modal-text'>Điểm thưởng: &nbsp;</p>" +
        "<p style='font-weight: bold; color:#ec164c'>" +
        codeResult.detail.point +
        "&nbsp; điểm</p>" +
        "</div>" +
        "<div class='modal-text-cont'>" +
        "<p class='modal-text'>" +
        codeResult.detail.mess +
        " : &nbsp;</p>" +
        "<p style='font-weight: 600'>" +
        time +
        "</p>" +
        "</div>" +
        "</div>",
      footer: '<a href="' + information?.cskh_url + '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng</a>',
    }).then(() => {
      window.location.reload();
    });
  } else {
    if (codeResult.valid === false) {
      Swal.fire({
        icon: "warning",
        title: codeResult.title_mess,
        text: codeResult.text_mess,
        footer: '<a href="' + information?.cskh_url + '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng.</a>',
      }).then(() => {
        window.location.reload();
      });
    } else if (codeResult.valid === true) {
      let time = moment(codeResult?.detail?.time).tz("Asia/Ho_Chi_Minh").format("YYYY/MM/DD H:mm:ss");
      Swal.fire({
        icon: "success",
        title: codeResult.title_mess,
        allowOutsideClick: false,
        html:
          "<div class='modal-text-wrapper'>" +
          "<div class='modal-text-cont'>" +
          "<p class='modal-text'>Mã khuyến mãi: &nbsp;</p>" +
          "<p style='font-weight: 600'>" +
          codeResult.detail.promo_code +
          "</p>" +
          "</div>" +
          "<div class='modal-text-cont'>" +
          "<p class='modal-text'>Điểm thưởng: &nbsp;</p>" +
          "<p style='font-weight: bold; color:#ec164c'>" +
          codeResult.detail.point +
          "&nbsp; điểm</p>" +
          "</div>" +
          "<div class='modal-text-cont'>" +
          "<p class='modal-text'>" +
          codeResult.detail.mess +
          " : &nbsp;</p>" +
          "<p style='font-weight: 600'>" +
          time +
          "</p>" +
          "</div>" +
          "</div>",
        footer: '<a href="' + information?.cskh_url + '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng</a>',
        input: "text",
        inputLabel: "Vui lòng nhập tên tài khoản để nhận thưởng",
        inputPlaceholder: "Tên tài khoản",
        showCancelButton: true,
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        inputValidator: async (playerID) => {
          if (!playerID) {
            return "Vui lòng nhập tên tài khoản!";
          } else {
            Swal.fire({
              text: "Đang cộng điểm ...",
              allowOutsideClick: false,
              width: 300,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            let addPoint = await addPointClient(playerID, codeResult.detail.promo_code);
            if (addPoint.status_code === 502) {
              Swal.fire({
                icon: "warning",
                title: addPoint.title_mess,
                text: addPoint.text_mess,
                footer: '<a href="' + information?.cskh_url + '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng.</a>',
              }).then(() => {
                window.location.reload();
              });
            } else {
              if (addPoint.valid === false) {
                Swal.fire({
                  icon: "error",
                  title: addPoint.title_mess,
                  text: addPoint.text_mess,
                  footer: '<a href="' + information?.cskh_url + '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng.</a>',
                }).then(() => {
                  window.location.reload();
                });
              } else if (addPoint.valid === true) {
                console.log("Done");
                document.getElementsByClassName("congrat-id")[0].innerHTML = addPoint.player_id;
                document.getElementsByClassName("congrat-score")[0].innerHTML = addPoint.point;
                document.getElementsByClassName("congrat-wrapper")[0].classList.add("congrat-margin");

                const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
                Toast.fire({
                  icon: "success",
                  title: "Cộng điểm thành công",
                });
              }
            }
          }
        },
      });
    }
  }
};
